module.exports = __webpack_public_path__ + "img/hr-red-asterisk-14.c7088a54.png";